var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTicketFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "outline",
    d: "M22,20.661H17v-.5a2,2,0,0,0-4,0v.5H4v-14h9v.5a2,2,0,1,0,4,0v-.5h5Zm-4.042-1H21v-12H17.958a3,3,0,0,1-5.916,0H5v12h7.042a3,3,0,0,1,5.916,0ZM15.5,12.307h-1v2.484h1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "filled",
    d: "M22,20.661H17v-.5a2,2,0,0,0-4,0v.5H4v-14h9v.5a2,2,0,1,0,4,0v-.5h5Zm-6.5-8.354h-1v2.484h1Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTicketFilled);
export default __webpack_public_path__ + "static/media/icon-ticket-filled.8c9d6b0d70121d329fc1c5f8cf984d43.svg";
export { ForwardRef as ReactComponent };